import { UI_DEFAULTS } from '../locale/labels';
export const DEFAULT_CHAT_UI_THEME = 'light';

/** @type {Record<'dark' | 'light', Record<string, string>>} */
export const CHAT_UI_THEME_TOKENS = {
  dark: {
    fontFamilyBody: '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", sans-serif',
    fontFamilyHeading: '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", sans-serif',
    appBg: '#10151f',
    appBorder: '#263044',
    appShadow: '0 18px 42px rgba(5, 8, 14, 0.38)',
    sidebarBg: '#0e1420',
    panelBg: '#131a28',
    divider: '#263044',
    surfaceBg: '#1a2232',
    surfaceBgActive: '#1f2f4a',
    surfaceBorder: '#33425b',
    surfaceBorderActive: '#4f8df8',
    textPrimary: '#e8edf7',
    textSecondary: '#a7b3c8',
    textMuted: '#8b98ae',
    textInverse: '#ffffff',
    iconNeutral: '#a4b1c6',
    iconMuted: '#8a97ac',
    bubbleUserBg: '#2e77f6',
    bubbleAssistantBg: '#1a2232',
    bubbleAssistantBorder: '#33425b',
    bubbleUserSubtleText: '#dbeafe',
    composerBg: '#121926',
    composerBoxBg: '#171f2f',
    inputText: '#e5eaf3',
    fileTagBg: 'rgba(46, 119, 246, 0.24)',
    fileTagBorder: 'rgba(137, 183, 255, 0.45)',
    fileTagText: '#d9e7ff',
    scenarioBg: '#131a28',
    scenarioCardBg: '#1a2232',
    scenarioCardBgActive: '#1f2f4a',
    scenarioCardBorder: '#33425b',
    scenarioCardBorderActive: '#4f8df8',
    focusOutline: '0 0 0 3px rgba(79, 141, 248, 0.28)',
  },
  light: {
    fontFamilyBody: '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", sans-serif',
    fontFamilyHeading: '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", sans-serif',
    appBg: '#eef3fb',
    appBorder: '#d4deec',
    appShadow: '0 16px 40px rgba(15, 23, 42, 0.09)',
    sidebarBg: '#f8fbff',
    panelBg: '#ffffff',
    divider: '#dce6f3',
    surfaceBg: '#ffffff',
    surfaceBgActive: '#eaf2ff',
    surfaceBorder: '#d4dfef',
    surfaceBorderActive: '#3b82f6',
    textPrimary: '#0f172a',
    textSecondary: '#475569',
    textMuted: '#7f8ea5',
    textInverse: '#ffffff',
    iconNeutral: '#54637d',
    iconMuted: '#8191a8',
    bubbleUserBg: '#2b6cf3',
    bubbleAssistantBg: '#ffffff',
    bubbleUserSubtleText: '#dbe8ff',
    composerBg: '#f7faff',
    composerBoxBg: '#ffffff',
    inputText: '#0f172a',
    fileTagBg: 'rgba(43, 108, 243, 0.12)',
    fileTagBorder: 'rgba(43, 108, 243, 0.3)',
    fileTagText: '#1d4ea2',
    scenarioBg: '#ffffff',
    scenarioCardBg: '#ffffff',
    scenarioCardBgActive: '#eaf2ff',
    scenarioCardBorder: '#d4dfef',
    scenarioCardBorderActive: '#3b82f6',
    focusOutline: '0 0 0 3px rgba(59, 130, 246, 0.22)',
    ...UI_DEFAULTS.theme,
    bubbleAssistantBorder: UI_DEFAULTS.theme.surfaceBorder,
  },
};
